import React from 'react';
import PropTypes from 'prop-types';
import InviteForm from './InviteForm';
import Modal from '../Modal';
import phrasesType from '../../proptypes/phrases';

const InviteModal = ({
  referralUrl,
  modalVisible,
  onClose,
  phrases,
  onCopy,
  onShare,
}) => (
  <Modal show={modalVisible} onClose={onClose} limitWidth>
    <InviteForm
      phrases={phrases.inviteFriends}
      referralUrl={referralUrl}
      onCopy={onCopy}
      onShare={onShare}
    />
  </Modal>
);

InviteModal.defaultProps = {
  onCopy: () => undefined,
  onShare: () => undefined,
};

InviteModal.propTypes = {
  referralUrl: PropTypes.string.isRequired,
  modalVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  phrases: phrasesType.isRequired,
  onCopy: PropTypes.func,
  onShare: PropTypes.func,
};

export default InviteModal;
